import styled from 'styled-components';
import { Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { SpinnerLoading } from '@/main/components/shared/styles';

export const ContainerButton = styled(Button)`
  &&& {
    width: 100%;
    max-width: 300px;
    background: ${({ theme }) => theme.pantone2726C};
    color: ${({ theme }) => theme.white};
    text-transform: none;
    padding: 0.6rem 0.8rem;
    box-shadow: 6px 4px 4px 2px rgba(0, 0, 0, 0.25);
    font-size: 0.9rem;

    &:disabled {
      background: #949494;
      border-color: #949494;
      color: ${({ theme }) => theme.white};
      filter: grayscale(100%);
      cursor: not-allowed;
    }
    ${SpinnerLoading} {
      margin: 0 0 0 auto;
    }
  }
`;

export const IconArrowRight = styled(ArrowBack)`
  margin-left: auto;
  transform: rotate(180deg);
`;

